import store from "@/state/store";

const redirectIfLoggedIn = (routeTo, routeFrom, next) => {
  if (store.getters["auth/loggedIn"]) next({ name: "default" });
  else next();
};

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/account/login.vue"),
    meta: { title: "Login", beforeResolve: redirectIfLoggedIn },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/account/register.vue"),
    meta: { title: "Register", beforeResolve: redirectIfLoggedIn },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("@/views/account/forgot-password.vue"),
    meta: { title: "Forgot Password", beforeResolve: redirectIfLoggedIn },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        next();
      },
    },
    component: () => import("@/views/auth/logout/basic"),
  },
];
